import React, { useEffect, useState } from 'react'
import { Button, CircularProgress } from '@mui/material';
import { getUserDefinedSSO, postUserDefinedSSO } from '../../features/manageSSO/manageSSOService';
import Switch from 'react-switch';

function SSOHome() {
    const [userDefinedEnabled , setUserDefinedEnabled] = useState<boolean>(false);
    const [loading , setLoading] = useState<boolean>(true);


    async function init(){
        setLoading(true);
        const isEnabled = await getUserDefinedSSO();
        setUserDefinedEnabled(isEnabled);
        setLoading(false);
    }

    async function updateUserDefinedStatus(value:boolean){
        setLoading(true);
        const isUpdated = await postUserDefinedSSO(value);
        if(isUpdated) setUserDefinedEnabled(value);
        setLoading(false);
    }

    useEffect(()=>{
        init();
    },[]);

    return (
        <div className='sso-home-wrapper'>
            <div className="sso-home-card">
                <h3 className="sso-home-card-heading">
                    User Defined SSO
                    {
                        loading &&
                        <CircularProgress sx={{ float: 'right' }} color="primary" size={"25px"} />
                    }
                </h3>
                <p className='sso-home-card-description'>
                    Activate single signon by user. Each user will define its own supported sso type. If enabled App Login will be determined by user record.
                </p>
                <Switch
                    className='sso-home-user-defined-enabled-switch'
                    onChange={updateUserDefinedStatus}
                    checked={userDefinedEnabled}
                    offColor="#d43136"
                    onColor="#24c6b1"
                    size={35}
                    disabled={loading}
                    translate={"yes"}
                    handleDiameter={30}
                    uncheckedIcon={
                        <>
                            <div className="sso-home-user-enabled-toggle-unchecked-icon-status">DISABLED</div>
                        </>
                    }
                    checkedIcon={
                        <>
                            <div className="sso-home-user-enabled-toggle-checked-icon-status">ACTIVATED</div>
                        </>
                    }
                    height={35}
                    width={120}
                />

            </div>
            <div className="sso-home-card">
                <h3 className="sso-home-card-heading">TRY IT!</h3>
                <p className='sso-home-card-description'>
                    Lets try sso by clicking button as shown below. You will be redirected to new window. You can find this option wrt each record.
                </p>
                <Button variant="outlined" className='sso-home-try-btn'>Try</Button>
            </div>
            <div className="sso-home-card">
                <h3 className="sso-home-card-heading">Operations</h3>
                <p className='sso-home-card-description'>
                    Each record has Edit(🖊️) , Delete(🗑️) options through you can modify configurations either using form or using Json editor
                </p>
            </div>
        </div>
    )
}

export default SSOHome